import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import Nav from "../components/Nav";
import dots from "../assets/images/dots.svg";
import http from "../services/http";
import polygon from "../assets/images/Polygon 56.png";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { SpinnerCircular } from "spinners-react";
import { Modal } from "react-bootstrap";
import dropdown from "../assets/images/dropdown.png";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import moment from "moment";
import { Space, Switch, Table, TableColumnGroupType, TableProps } from 'antd';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SendVideoLink = () => {
  const token = localStorage.getItem("xAuthToken");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [validTeam_id, setValidTeam_id] = useState(true);
  const [validTeamGroupId, setValidTeamGroupId] = useState(true);
  const [showModal, setShow] = useState(false);
  const [showModals, setShows] = useState(false);
  const [validSwimmerId, setValidSwimmerId] = useState(true);

  const [teams, setTeams] = useState([]);
  const [swimmers, setSwimmers] = useState([]);
  const [teamGroupData, setTeamGroupData] = useState([]);
  const [swimmersRecordings, setSwimmersRecordings] = useState([]);

  const [team_id, setTeamId] = useState(0);
  const [swimmerId, setSwimmerId] = useState("0");
  const [teamGroupId, setTeamGroupId] = useState("0");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const currentYearFirstDate = new Date(new Date().getFullYear(), 0, 1).toString();
  const today = new Date().toString();
  const [dateRange, setDateRange] = useState([currentYearFirstDate, today]);
  const [startDate, endDate] = dateRange;


  const columns = [
    {
      title: 'Name',
      dataIndex: 'firstname',
      width: '15%',
      render: (_, record) => (
        <>{record.firstname} {record.lastname}</>
      ),
    },
    {
      title: 'Cam 1',
      dataIndex: 'outputFilenameCam1',
      width: '35%',
      render: (_, record) => (
        <div className="video-text-word-wrap">{record.outputFilenameCam1}</div>
      ),
    },
    {
      title: 'Cam 2',
      dataIndex: 'outputFilenameCam2',
      width: '35%',
      render: (_, record) => (
        <div className="video-text-word-wrap">{record.outputFilenameCam2}</div>
      ),
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      width: '15%',
      render: (_, record) => (
        <>{moment(record.created_at).format(
          "MMM Do YY"
        )}</>
      )
    },
  ]

  useEffect(() => {
    loadTeams();
  }, []);

  useEffect(() => { }, [swimmersRecordings])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const navigate = useNavigate();

  const handleCloses = () => {
    setShows(false);
    setError("");
  };


  const loadTeams = () => {
    http
      .get(`api/admin/team?token=${token}`)
      .then((res) => {
        setTeams(res.data);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const loadSwimmer = (teamSelection, groupId) => {
    const team = teamSelection != null ? String(teamSelection) : "0";
    if (team === "0" || team === "") {
      setSwimmers([]);
      return;
    }
    const group = groupId != null ? String(groupId) : "0";
    let url = `api/admin/teamgroup/swimmersByTeamOrGroup?team_id=${team}&token=${token}`;
    if (group !== "0" && group !== "") {
      url += `&group_id=${group}`;
    }
    http
      .get(url)
      .then((res) => {
        setSwimmers(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setSwimmers([]);
        setLoading(false);
      });
  };

  const loadTeamGroup = (team_id) => {
    http
      .get(`api/teamgroup/byteam/${team_id}?token=${token}`)
      .then((res) => {
        setTeamGroupData(res.data);
        setLoading(false);

      })
      .catch((error) => {
        console.log("error in coach portal", error);
        setLoading(false);
      });
  }

  const loadSwimmerVideos = (teamId, groupId, swimmerId,dateSelection) => {
    http
      .get(`api/admin/swimmer/sendswimmervideos/${teamId}/${groupId}/${swimmerId}?&startDate=${moment(dateSelection != undefined ? dateSelection[0] : dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateSelection != undefined ? dateSelection[1] :dateRange[1]).format("YYYY-MM-DD")}&token=${token}`)
      .then((res) => {
        const datasource = res.data.map((item) => {
          return {
            key: item.id,
            ...item
          }
        })
        setSwimmersRecordings(datasource);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }

  const handleChangesTeam = (event) => {
    setSelectedRowKeys([]);
    setTeamGroupId("0");
    setSwimmerId("0");
    if (event.target.value === "0") {
      setTeamGroupData([]);
      setSwimmers([]);
    }
    if (event.target.value !== "0") {
      setValidTeam_id(false);
    }
    setTeamId(event.target.value);
    if (event.target.value !== "0") {
      loadTeamGroup(event.target.value);
      loadSwimmer(event.target.value, "0");
      loadSwimmerVideos(event.target.value, "0", "0");
    }
  };

  const handleChangesTeamGroup = (event) => {
    setSelectedRowKeys([]);
    setSwimmerId(0);
    if (event.target.value === "0") {
      setSwimmerId(0);
    }
    if (event.target.value !== "0") {
      setValidTeamGroupId(false);
    }
    setTeamGroupId(event.target.value);
    loadSwimmer(team_id, event.target.value);
    loadSwimmerVideos(team_id, event.target.value, "0")
  };


  const handleChangesSwimmer = (event) => {
    setSelectedRowKeys([]);
    setSwimmerId(event.target.value);
    if (event.target.value !== "0") {
      setValidSwimmerId(false);
    }
    loadSwimmerVideos(team_id, teamGroupId, event.target.value)
  };

  const handleShows = (id) => {
    if (team_id === "0") {
      console.log("team_id", team_id);
      setError("Required");
      setValidTeam_id(true);
      return;
    }
    // if (swimmerId === "0" || swimmerId === 0) {
    //   console.log("swimmerId", swimmerId);
    //   setError("Required");
    //   setValidSwimmerId(true);
    //   return;

    // }
    if (selectedRowKeys.length === 0) {
      showToast("error", "Select At least one video link");
      return;

    }
    setLoading(true);

    let parentPortalLink = "https://argo-parent-portal.herokuapp.com/track"

    const selectedVideosLinks = swimmersRecordings.filter((item) => selectedRowKeys.includes(item.id)).map((item) => {
      return {
        id: item.id,
        video_url: `${parentPortalLink}/${item.id}/${item.parent_id}`,
        outputFilenameCam1: item.outputFilenameCam1,
        outputFilenameCam2: item.outputFilenameCam2,
        created_at: moment(item.created_at).format("DD MMM, YYYY"),
        swimmer_name: item.firstname + ' ' + item.lastname,
        swimmer_id: item.swimmer_id
      }
    });
    http
      .post(`api/admin/swimmer/sendvideos/${swimmerId}?token=${token}`, { selctedVideos: selectedVideosLinks })
      .then((res) => {
        setLoading(false);
        showToast("success", res.data.message);


      })
      .catch((error) => {
        setLoading(false);
      });
    // http.get(`api/common/categories?token=${token}`).then((res) => {
    //   setCategories(res.data);
    //   setLoading(false);
    // });
    setShows(true);
  };

  const handleDatePicker = (dateSelection) => {
    setSelectedRowKeys([]);

    setDateRange(dateSelection);
    if((dateSelection[0] != null && dateSelection[1] != null)|| (dateSelection[0] == null && dateSelection[1] == null)){
      if(Number(team_id) != 0){
        loadSwimmerVideos(team_id, teamGroupId,swimmerId,dateSelection )
      }

    }

  }


  return (
    <>
      <div class="wrapper">
        <Nav />
        <div id="content">
          <ToastContainer />

          <header>
            <div class="dashboard_header">
              <div class="left-side d-flex ">
                {" "}
                <button
                  type="button"
                  id="sidebarCollapse"
                  class="btn btn-link bt_none"
                >
                  <i class="fa fa-align-left"></i>{" "}
                </button>
                <h1>Send Video Link</h1>
              </div>
              <div class="user_profile   ">
                <DropdownRight />
              </div>
            </div>
          </header>
          <div class="dashbord_content">
            <div class="analysts-wraper-head">
              <div class="form-group search_wraper"></div>

            </div>
            <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
              <div className="map_btn">
                <div class="form-group icon mx-0 Edit_Setting  mb-2">
                  <select
                    onChange={handleChangesTeam}
                    name="Team" value={team_id}
                    className="custom_input form-control mb-0 "
                  >
                    <option value="0" >
                      Select Team
                    </option>

                    {teams?.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <div className="img_icon">
                    <img src={dropdown} alt="" />{" "}
                  </div>
                  {
                    validTeam_id &&
                    <div class="form-group">
                      <p class="text-danger">{error}</p>
                    </div>
                  }
                </div>
                <div class="form-group icon mx-0 Edit_Setting  mb-2">
                  <select
                    onChange={handleChangesTeamGroup}
                    name="TeamGroup" value={teamGroupId}
                    className="custom_input form-control mb-0 "
                  >
                    <option value="0" >
                      Select Team Group
                    </option>

                    {teamGroupData?.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  <div className="img_icon">
                    <img src={dropdown} alt="" />{" "}
                  </div>
                  {
                    validTeamGroupId &&
                    <div class="form-group">
                      <p class="text-danger">{error}</p>
                    </div>
                  }
                </div>
                <div class="form-group icon mx-0 Edit_Setting mb-2" >
                  <select
                    onChange={handleChangesSwimmer}
                    name="Swimmer" value={swimmerId}
                    className="custom_input form-control mb-0 "
                  >
                    <option value="0" >
                      Select Swimmer
                    </option>

                    {swimmers?.map((item, i) => (
                      <option key={i} value={item.id} >
                        {item.firstname} {item.lastname}
                        {/* {item.fullname} */}
                      </option>
                    ))}
                  </select>
                  <div className="img_icon">
                    <img src={dropdown} alt="" />{" "}
                  </div>
                  {/* {
                    validSwimmerId &&
                    <div class="form-group">
                      <p class="text-danger">{error}</p>
                    </div>
                  } */}
                </div>
                <div class="form-group icon mx-0 Edit_Setting mb-2">
        
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      handleDatePicker(update)
                    }}
                    isClearable={true}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className="custom_dashboard_datepicker"
                    placeholderText="Select date range"
                    popperPlacement="right-start"
                  />
                </div>
                <div class="form-group icon mx-0 Edit_Setting">
                  {" "}
                  <button
                    class="them_btn"
                    type="button"
                    data-toggle="modal"
                    data-target="#Google_Meet"
                    onClick={handleShows}
                  >
                    Send Video Link
                  </button>{" "}


                </div>
              </div>
            </div>
            <div class="mt-3">
              <Table className="table table-borderless table-responsive-md "
                columns={columns}
                rowSelection={rowSelection}
                // rowSelection={{ ...rowSelection, checkStrictly }}
                dataSource={swimmersRecordings}
                loading={loading}
                pagination={{ defaultPageSize: 20 }}
              />
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default SendVideoLink;
